/**
    method: 'post' | 'get' | 'put' | 'delet'
    url: String | (params) => url

*/

/** ******** 登录模块 ********* */

// 登录
export const login = {
  method: 'post',
  url: '/user/admin/login.json'
};

export const getUserType = {
  url: '/admin/information/getUserType.json',
  method: 'get'
};

// 获取publicKey
export const getPlulicKey = {
  method: 'get',
  url: '/mobile/enciphermentController/getPubKey.json'
};

// 获取菜单
export const getRouteList = {
  method: 'get',
  url: '/resource/findManuByRoleId.json'
};
